import { render } from "./Sidebar.vue?vue&type=template&id=08b2b96c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=08b2b96c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/fast-blockchains-dashboard/fast-blockchains-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b2b96c"]])

export default __exports__